// "Show working" (S157): whether conversations show the agent's interim messages and tool calls
// as rows, or fold them into the Thinking row so the prompt, the questions and the answer stand
// out. Off by default; remembered per browser (a convenience: storage may be missing), and every
// switch on the page follows the same choice.
import { useSyncExternalStore } from "react";

const KEY = "ocs.conversation.showWorking";
const listeners = new Set<() => void>();

function read(): boolean {
  try {
    return localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

let current = read();

export function setShowWorking(show: boolean): void {
  current = show;
  try {
    localStorage.setItem(KEY, show ? "1" : "0");
  } catch {
    // private window or blocked storage: the choice lasts this page only
  }
  listeners.forEach((l) => l());
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function useShowWorking(): boolean {
  return useSyncExternalStore(subscribe, () => current);
}
